import React, { useState } from 'react';
import { Modal, VStack, Input } from 'native-base';
import { Txt } from './Typography';
import { Button } from './Theme';
import { useTheme } from '@springbig/shared';

type EmailVerificationModalProps = {
    isOpen: boolean;
    onClose: () => void;
    currentEmail?: string;
    onSubmit: (email: string) => void;
    isLoading?: boolean;
};

const EmailVerificationModal = ({
    isOpen,
    onClose,
    currentEmail = '',
    onSubmit,
    isLoading = false,
}: EmailVerificationModalProps) => {

    const [updatedEmail, setUpdatedEmail] = useState('');
    const { primary } = useTheme();

    const handleClose = () => {

        setUpdatedEmail('');
        onClose();
    };

    const handleSubmit = () => {

        const trimmedEmail = updatedEmail.trim();

        if (!trimmedEmail) {
            return;
        }

        onSubmit(trimmedEmail);
    };

    const isEmailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(updatedEmail.trim());

    return (
        <Modal isOpen={isOpen} onClose={handleClose}>
            <Modal.Content maxWidth="400px" borderRadius="20px">
                <Modal.CloseButton />
                <Modal.Body p={6}>
                    <VStack space={4}>
                        <Txt fontSize={24} fontWeight="600" color="gray.900">
                            Verify Your Email
                        </Txt>

                        <Txt fontSize={14} color="gray.700" lineHeight={20}>
                            We&apos;ll send a verification email to confirm your email address and complete your enrollment in marketing communications.
                        </Txt>

                        <VStack space={2}>
                            <Txt fontSize={14} fontWeight="500" color="gray.900">
                                Email Address
                            </Txt>
                            <Input
                                value={updatedEmail}
                                onChangeText={setUpdatedEmail}
                                placeholder={currentEmail}
                                fontSize={14}
                                borderWidth={1}
                                borderColor="gray.300"
                                borderRadius="8px"
                                px={4}
                                py={3}
                                bg="white"
                                _focus={{
                                    borderColor: primary,
                                    bg: 'white'
                                }}
                            />
                        </VStack>

                        <Txt fontSize={13} color="gray.600" lineHeight={18}>
                            After you click &quot;Send Email Confirmation&quot;, check your inbox for a verification email. Click the link in the email to complete your enrollment. <Txt fontWeight="600">This link will expire in 3 days.</Txt> You can unsubscribe from marketing communications at any time.
                        </Txt>

                        <Button
                            text="Send Email Confirmation"
                            onPress={handleSubmit}
                            loading={isLoading}
                            disabled={!isEmailValid}
                        />
                    </VStack>
                </Modal.Body>
            </Modal.Content>
        </Modal>
    );
};

export default EmailVerificationModal;
